import Settings from "@mui/icons-material/Settings"
import { Box, Grid, Link, Typography } from "@mui/material"
import * as React from "react"
import { useEffect } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import { pagesUrl } from "../../core/appConstants"
import { AppSideBarContext } from "../../core/context/AppSideBarContext/AppSideBarContext"
import { AppNavBarContext } from "../../core/context/nav-bar/AppNavBarContext"
import { OrganizationContext } from "../../core/context/organization/organization-context"
import { formatToFrench } from "../../core/services/date-service"
import { resolveUrl } from "../../core/services/http-service"
import { OfferCard } from "./OfferCard"

export function MyOfferPage(): React.JSX.Element {
  const location = useLocation()
  const [searchParams] = useSearchParams()

  const { organization, refreshOrganization } = React.useContext(OrganizationContext)
  const { setShowAppSide } = React.useContext(AppSideBarContext)
  const { setTitle, setPreviousUrl, setBreadcrumbSteps, setIcon } = React.useContext(AppNavBarContext)

  useEffect(() => {
    const projectId = searchParams.get("projectId")
    const tab = searchParams.get("tab")

    setShowAppSide(true)
    setTitle("Mon offre")
    setIcon(<Settings />)
    setBreadcrumbSteps([{ label: "Mon offre" }])
    if (projectId) {
      setPreviousUrl(resolveUrl(pagesUrl.PROJECT_PAGE_DETAIL, [projectId], { tab }))
    } else {
      setPreviousUrl(pagesUrl.HOME)
    }
  }, [setShowAppSide, location, setTitle, setPreviousUrl, setIcon, setBreadcrumbSteps, searchParams])

  useEffect(() => {
    // This is to ensure licence count is up to date when we arrive on the page
    refreshOrganization()
  }, [refreshOrganization])

  return (
    <Grid
      container
      display="flex"
      justifyContent="space-around"
      alignItems="flex-start"
      borderRadius={3}
      gap={3}
      p={3}
      sx={{ backgroundColor: "white" }}>
      <Grid item xs={12}>
        <Typography fontSize={24} fontWeight={600}>
          Inclus dans votre offre
        </Typography>
      </Grid>
      <Grid item xs={12} display="flex" flexDirection="row" alignItems="center" gap={1}>
        {organization?.createdDate && (
          <>
            <Typography variant="body2">Depuis le</Typography>
            <Typography fontSize={14} fontWeight={600}>
              {formatToFrench(new Date(organization?.createdDate))}
            </Typography>
          </>
        )}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1">Vos abonnements vous permettent d’accéder aux services Time To Beem :</Typography>
      </Grid>
      <Grid item xs={12} sx={{ display: "flex" }}>
        <OfferCard
          label="Crédit Beem Shot"
          maxLicense={organization?.maxProjectEstimationCount}
          countLicense={organization?.projectEstimationCounter}
          isOptionActive
        />
        <OfferCard
          label="Nombre de maquettes"
          maxLicense={organization?.bsMaxBimModelCount}
          countLicense={organization?.bsBimModelCounter}
          isOptionActive
        />
        <OfferCard
          label="Nombre de fichiers RSEE"
          maxLicense={organization?.maxRseeDocumentCount}
          countLicense={organization?.rseeDocumentCounter}
          isOptionActive
        />
      </Grid>
      <Grid item xs={12}>
        <OfferCard
          label="Collaborateurs"
          maxLicense={organization?.maxLicenceCount}
          countLicense={organization?.licenceCounter}
          isOptionActive
          backgroundColor="#0D6E58"
        />
      </Grid>
      <Grid item xs={12}>
        <Box>
          Si vous souhaitez augmenter votre nombre de licences, contactez-nous à l'adresse{" "}
          <Link href="mailto:contact@timetobeem.com">contact@timetobeem.com</Link>
        </Box>
      </Grid>
    </Grid>
  )
}
